import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { DescriptionFieldSet } from '@wix/ambassador-challenges-v1-challenge/types';
import { requestStepV3 } from '../storage-contexts/Challenge/api/requestStepV3';
import { Step } from '../../types/v3Types';
import { handleError } from '../ErrorHandler/errorHandlerPropsMap';

export type ExtendedStepMap = { [id: string]: Step };

export const extendedStepMap: ExtendedStepMap = {};

export const updateExtendedStepMap = (
  sourceStep: Step,
  participantStepId: string,
) => {
  extendedStepMap[participantStepId] = sourceStep;
};

export async function requestParticipantStep(
  stepId: string,
  flowAPI: ControllerFlowAPI,
): Promise<void> {
  try {
    flowAPI.panoramaClient.transaction('get-step').start();

    const step = await requestStepV3(
      { stepId, descriptionFieldSet: DescriptionFieldSet.EXTENDED },
      flowAPI,
    );
    updateExtendedStepMap(step, stepId);

    flowAPI.controllerConfig.setProps({
      extendedStepMap,
    });

    flowAPI.panoramaClient.transaction('get-step').finish();
  } catch (err) {
    const resolvedError = flowAPI.errorHandler.getResolvedError(err);
    handleError({
      error: err,
      resolvedError,
      context: 'requestParticipantStep',
      preventErrorMonitorReport: false,
    });
  }
}
